import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ApplicationComponent } from './application.component';
import { StudentDetailsComponent } from './student-details/student-details.component';
import { VisaOhscComponent } from './visa-ohsc/visa-ohsc.component';
import { ApplicationEditComponent } from './application-edit/application-edit.component';
import { StudentValidationComponent } from './student-validation/student-validation.component';
import { ParentsValidationComponent } from './parents-validation/parents-validation.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ImportantInformationComponent } from './important-information/important-information.component';
import { StudentsParentsValidationComponent } from './students-parents-validation/students-parents-validation.component';
import { AuthGuard } from '../shared/services/auth.guard.service';
import { AuthResolverService } from '../shared/services/auth.resolver.service';
import { ParentGuardianDetailsComponent } from './parent-guardian-details/parent-guardian-details.component';
import { CanDeactivateGuard } from '../shared/services/can-deactivate.guard.service';
import { SchoolProgramPlacementComponent } from './school-program-placement/school-program-placement.component';
import { AccommodationWelfareComponent } from './accommodation-welfare/accommodation-welfare.component';
import { EnglishProficiencyComponent } from './english-proficiency/english-proficiency.component';
import { SpecialCircumstancesComponent } from './special-circumstances/special-circumstances.component';
import { DefaultCorrespondentComponent } from './default-correspondent/default-correspondent.component';
import { SupportingDocumentsComponent } from './supporting-documents/supporting-documents.component';
import { SummaryComponent } from './summary/summary.component';
import { RelationshipTypesResolverService,
         CountryResolverService,
         VisaSubClassesResolverService,
         OHSCProvidersResolverService,
         SchoolSubjectResolverService,
         SchoolsResolverService,
         DurationsResolverService,
         TermsResolverService,
         ParentGuardianResolverService,
         SummaryResolverService,
         SummaryWithDocumentsService} from '../shared/services/resolvers.service';
import {
  ParentGuardianDetailsEditComponent } from './parent-guardian-details/parent-guardian-details-edit/parent-guardian-details-edit.component';
import { ApplicationPaymentComponent } from './application-payment/application-payment.component';
import { AgentDashboardComponent } from './agent-dashboard/agent-dashboard.component';
import { AgentStudentRegistrationComponent } from './agent-student-registration/agent-student-registration.component';
import { AgentStudentRegistrationGdprComponent } from './agent-student-registration-gdpr/agent-student-registration-gdpr.component';
import { ParentLegalcustodianEditComponent } from './parent-guardian-details/parent-legalcustodian-edit/parent-legalcustodian-edit.component';
import { ApplicationAgentDetailsComponent } from './application-agent-details/application-agent-details.component';


const routes: Routes = [
  {
    path: 'applications',
    component: ApplicationComponent,
    canActivate: [AuthGuard],
    resolve: {currentUser: AuthResolverService},
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'agent-dashboard',
        component: AgentDashboardComponent,
      },
      {
        path: 'agent-student-registration',
        component: AgentStudentRegistrationComponent,
        resolve: { countries: CountryResolverService}
      },
      {
        path: 'agent-student-registration-gdpr',
        component: AgentStudentRegistrationGdprComponent,
      },
      {
        path: 'student-parents-validation',
        component: StudentsParentsValidationComponent,
        resolve: { countries: CountryResolverService}
      },
      {
        path: 'student-validation',
        component: StudentValidationComponent,
        resolve: { countries: CountryResolverService}
      },
      {
        path: 'parents-validation',
        component: ParentsValidationComponent
      },
      {
        path: ':id/edit',
        component: ApplicationEditComponent,
        children: [
        {
          path: 'important-information',
          component: ImportantInformationComponent
        },
        {
          path: 'student-details',
          component: StudentDetailsComponent,
          resolve: { countries: CountryResolverService},
          canDeactivate: [CanDeactivateGuard]
        },
        {
          path: 'parent-guardian-details',
          resolve: { countries: CountryResolverService, relationshipTypes: RelationshipTypesResolverService},
          children: [
            {
              path: '',
              component: ParentGuardianDetailsComponent,
              resolve: { parentGuardianDetails: ParentGuardianResolverService }
            },
            {
              path: ':parentGuardianId/edit',
              component: ParentGuardianDetailsEditComponent,
              canDeactivate: [CanDeactivateGuard]
            },
            {
              path: 'parent-legalcustodian',
              component: ParentLegalcustodianEditComponent,
              canDeactivate: [CanDeactivateGuard]
            }
          ]
        },
        {
          path: 'visa-oshc',
          component: VisaOhscComponent,
          resolve: { visaSubClasses: VisaSubClassesResolverService, ohscProviders: OHSCProvidersResolverService },
          canDeactivate: [CanDeactivateGuard]
        },
        {
          path: 'school-program-placement',
          component: SchoolProgramPlacementComponent,
          resolve: {
                      schoolSubjects: SchoolSubjectResolverService,
                      schools: SchoolsResolverService,
                      terms: TermsResolverService,
                      durations: DurationsResolverService
                   },
          canDeactivate: [CanDeactivateGuard]
        },
        {
          path: 'accommodation-welfare',
          component: AccommodationWelfareComponent,
          canDeactivate: [CanDeactivateGuard]
        },
        {
          path: 'english-proficiency',
          component: EnglishProficiencyComponent,
          canDeactivate: [CanDeactivateGuard]
        },
        {
          path: 'special-circumstances',
          component: SpecialCircumstancesComponent,
          canDeactivate: [CanDeactivateGuard]
        },
        {
          path: 'default-correspondent',
          component: DefaultCorrespondentComponent,
          canDeactivate: [CanDeactivateGuard]
        },
        {
          path: 'supporting-documents',
          component: SupportingDocumentsComponent,
          resolve: { summaryWithDocuments: SummaryWithDocumentsService },
          canDeactivate: [CanDeactivateGuard]
        },
        {
          path: 'summary',
          component: SummaryComponent,
          resolve: {
                      countries: CountryResolverService,
                      schools: SchoolsResolverService,
                     summary: SummaryResolverService,
                     schoolSubjects: SchoolSubjectResolverService,
                     terms: TermsResolverService,
                     durations: DurationsResolverService,
                     relationshipTypes: RelationshipTypesResolverService }
        },
        {
          path: 'agent-details',
          component: ApplicationAgentDetailsComponent,
          resolve: { countries: CountryResolverService },
          canDeactivate: [CanDeactivateGuard]
        },
        {
          path: 'payment/:paymentStatus',
          component: ApplicationPaymentComponent,
        },
        {
          path: 'payment',
          component: ApplicationPaymentComponent,
        },
       ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApplicationRoutingModule { }
